import { createFilledIcon } from '@ps/ds/icons/helpers/createFilledIcon'

export const Progress25 = createFilledIcon('Progress25', [
  [
    'path',
    {
      d: 'M21.125 12C21.125 6.9604 17.0396 2.875 12 2.875C6.9604 2.875 2.875 6.9604 2.875 12C2.875 17.0396 6.9604 21.125 12 21.125C17.0396 21.125 21.125 17.0396 21.125 12ZM22.875 12C22.875 18.0061 18.0061 22.875 12 22.875C5.9939 22.875 1.125 18.0061 1.125 12C1.125 5.9939 5.9939 1.125 12 1.125C18.0061 1.125 22.875 5.9939 22.875 12Z',
      stroke: 'none',
      key: 'Progress25-0',
    },
  ],
  [
    'path',
    {
      d: 'M19.5 12C19.5 11.0151 19.306 10.0398 18.9291 9.12987C18.5522 8.21993 17.9997 7.39314 17.3033 6.6967C16.6069 6.00026 15.7801 5.44781 14.8701 5.0709C13.9602 4.69399 12.9849 4.5 12 4.5V12H19.5Z',
      stroke: 'none',
      key: 'Progress25-1',
    },
  ],
])

Progress25.displayName = 'Progress25'
